module.exports = __webpack_public_path__ + "static/media/DSC_0239.451df8aa.JPG";